/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
import { Button, CustomHeader, Screen, Text } from "components"
import React, { useCallback, useEffect, useState } from "react"
import { View, useWindowDimensions, Image, TouchableOpacity } from "react-native"
import { style } from "./styles"
import { useFocusEffect, useNavigation } from "@react-navigation/native"
import { colors } from "colors"
import moment from "moment"
import { translate } from "i18n"
import useResponsiveWidth from "components/fitSize"

import LinearGradient from "react-native-linear-gradient"
import { Bar } from "react-native-progress"
import { useSessionExpired } from "utils/function"
import { useStores } from "models"
import { ActivityIndicator } from "react-native-paper"
import TierCard from "components/TierCard"

export const MemberScreen = () => {
  const { userStore } = useStores()
  const { sessionExpired } = useSessionExpired()
  const navigation = useNavigation<any>()
  const [point, setPoint] = useState(0)
  const [loading, setLoading] = useState(false)

  useFocusEffect(
    useCallback(() => {
      setPoint(10)
    }, []),
  )

  const getResponsiveWidth = useResponsiveWidth()
  const { width } = getResponsiveWidth()
  const barWidth = width * (0 / 100)

  useEffect(() => {
    setLoading(true)
    getTierByUserId()
  }, [])

  const [tierLevel, setTierLevel] = useState<any>([
    { currentTier: "", point: 0, nextPoint: 0, icon: null },
  ])
  const [tierBenefit, setTierBenefit] = useState([])

  const getTierByUserId = async () => {
    try {
      // Fetch the member's tier data
      const userTierResponse = await fetch(
        `${process.env.API_URL}/api/tier/member/${userStore.id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userStore?.accessToken}`,
          },
        },
      )

      if (!userTierResponse.ok) {
        const errorMsg = await userTierResponse.json()
        if (["Token expired", "Invalid token"].includes(errorMsg?.error)) {
          sessionExpired()
        }
        return // Exit early on error
      }

      const userTierData = await userTierResponse.json()
      console.log("User Tier Data ===>", userTierData)

      const memberTier = userTierData?.get_member_tier_info?.[0]
      if (!memberTier) return // Exit if no tier data is found

      const currentTierId = userTierData?.current_tier

      // Fetch the current tier details
      const currentTierResponse = await fetch(`${process.env.API_URL}/api/tier/${currentTierId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userStore?.accessToken}`,
        },
      })

      if (!currentTierResponse.ok) {
        const errorMsg = await currentTierResponse.json()
        if (["Token expired", "Invalid token"].includes(errorMsg?.error)) {
          sessionExpired()
        }
        return // Exit early on error
      }

      const currentTierData = await currentTierResponse.json()
      console.log("Current Tier Data ===>", currentTierData)

      const currentTierInfo = currentTierData?.[0]
      if (!currentTierInfo) return // Exit if no tier data is found

      // Combine both data sets into one state update
      setTierLevel([
        {
          point: memberTier.sum_sales,
          nextPoint: memberTier.next_tier_amt ?? "MAX", // Using nullish coalescing for "MAX"
          nextTierName: memberTier?.next_tier_name, // Using nullish coalescing for "MAX"
          currentTier: currentTierInfo.tier_name?.toLowerCase(),
          icon: currentTierInfo.tier_image,
          expiry: userTierData.membership_expiry_date,
          allData: memberTier,
        },
      ])
      setTierBenefit(currentTierInfo.benefits)
      setLoading(false)
    } catch (error) {
      console.error("Error fetching tier data:", error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <CustomHeader
        headerTitle={translate("memberScreen.pageTitle")}
        headerRight={() => {
          return (
            <TouchableOpacity onPress={() => navigation.navigate("memberShip")}>
              <Text style={[style.showAllText, { color: "white" }]}>
                {translate("common.showAll")}
              </Text>
            </TouchableOpacity>
          )
        }}
      />

      <Screen preset="scroll">
        <View style={style.container}>
          <View>
            <TierCard loading={loading} tierLevel={tierLevel} />
            <View style={style.TierTitleContainer}>
              <Text style={[style.tierTitle, { fontSize: 20 }]}>
                Your Tier Benefits and Rewards
              </Text>
              {tierBenefit.map((benefit, index) => (
                <View
                  key={index}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    marginTop: 20,
                  }}
                  // onPress={() => navigation.navigate("redeem")}
                >
                  <Image
                    source={{
                      uri: benefit?.benefit_image,
                    }}
                    style={style.pointImage}
                  />
                  <View>
                    <Text style={style.benefitText}>{benefit.benefit_title}</Text>
                    <Text style={style.benefitDesc}>{benefit.benefit_description}</Text>
                  </View>
                </View>
              ))}
            </View>

            {/* <Button
              style={style.button}
              title="My Point"
              onPress={() => navigation.navigate("pointHistory")}
            /> */}
          </View>
        </View>
      </Screen>
    </>
  )
}
